var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AppHeader',{attrs:{"title":"마이페이지"}}),_c('AppContent',[_c('MyPageDetail')],1),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }